import { useEffect, useState } from "react";

import { getApi } from "../../api/api";
import {
  CategoryInterface,
  SaleItemInterface,
} from "../../common/types/interfaces";
import { useCityId } from "../../common/hooks/useCityId";

export const useMainSearch = (query: string, isDebouncing: boolean) => {
  const cityId = useCityId()

  const [categories, setCategories] = useState<CategoryInterface[]>([]);
  const [items, setItems] = useState<SaleItemInterface[]>([]);
  const [isFetching, setIsFetching] = useState(false);

  useEffect(() => {
    if (!query.trim()) {
      setCategories([]);
      setItems([]);
      return;
    }

    if (isDebouncing) return;

    let cancelled = false;
    setIsFetching(true);

    Promise.all([
      getApi().getCategories({ cityId }),
      getApi().getItems({ search: query, limit: 10, cityId }),
    ])
      .then(([catsRes, itemsRes]) => {
        if (cancelled) return;

        const lower = query.toLowerCase();
        const filteredCats = catsRes.data.filter(
          (c) =>
            c.name?.toLowerCase().includes(lower) ||
            c.description?.toLowerCase().includes(lower),
        );

        setCategories(filteredCats);
        setItems(itemsRes.data);
      })
      .catch(() => {
        if (!cancelled) {
          setCategories([]);
          setItems([]);
        }
      })
      .finally(() => {
        if (!cancelled) setIsFetching(false);
      });

    return () => {
      cancelled = true;
    };
  }, [query, isDebouncing, cityId]);

  return { categories, items, isFetching };
};
